import { Spinner, SpinnerSize } from "@fluentui/react";
import {
  AddOnlineMeetingIcon,
  CellPhoneIcon,
  ChevronDownMedIcon,
  ChevronRightMedIcon,
  NetworkTowerIcon,
  ParkingLocationIcon,
  PhoneIcon,
  TelemarketerIcon
} from "@fluentui/react-icons-mdl2";

import {
  Invoice,
  InvoiceStatusEnum,
  InvoiceStatusLabel,
  Tariff
} from "../../interfaces/invoices-response";
import InvoiceResume from "../invoiceResume/invoice-resume";
import TariffItem from "../tariffItem/tariff-item";

import {
  Card,
  ChevronAndBadgeContainer,
  Content,
  Header,
  HeaderContent,
  InvoiceBadge,
  InvoiceInfo,
  InvoiceServiceContainer,
  InvoiceTitle,
  InvoiceTotal,
  Separator,
  TariffList
} from "./style";

import { parseDateToMonthYear } from "@/utils/FormatDate";
interface InvoiceCardProps {
  invoice: Invoice;
  expanded: boolean;
  selectedTariff?: Tariff;
  onToggle: (invoiceId: number) => void;
  onTariffSelect: (tariff: Tariff) => void;
  customTariffs?: Tariff[];
  isLoadingTariffs?: boolean;
  currentInvoiceId?: number;
  document: string;
}

export default function InvoiceCard({
  invoice,
  expanded,
  selectedTariff,
  onToggle,
  onTariffSelect,
  customTariffs,
  isLoadingTariffs = false,
  currentInvoiceId
}: InvoiceCardProps) {
  const { month, year } = parseDateToMonthYear(invoice?.dueDate);

  const invoiceStatusMap: Record<InvoiceStatusEnum, InvoiceStatusLabel> = {
    [InvoiceStatusEnum.OPEN]: InvoiceStatusLabel.OPEN,
    [InvoiceStatusEnum.CLOSED]: InvoiceStatusLabel.CLOSED,
    [InvoiceStatusEnum.CANCELED]: InvoiceStatusLabel.CANCELED
  };

  const getServiceIcon = (serviceType: string) => {
    switch (serviceType) {
      case "Telefonia":
        return <CellPhoneIcon />;
      case "Tag do Sicoob":
        return <ParkingLocationIcon />;
      case "Rastreador":
        return <NetworkTowerIcon />;
      case "Conectividade Fixa":
        return <PhoneIcon />;
      case "PABX":
        return <AddOnlineMeetingIcon />;
      case "Linhas de Telemetria":
        return <NetworkTowerIcon />;
      case "Projeto 24h Segurado Sicoob":
        return <TelemarketerIcon />;
      default:
        return <CellPhoneIcon />;
    }
  };

  const renderServices = (services: string[]) => {
    return (
      <>
        {services.map((service, index) => (
          <span key={index}>{getServiceIcon(service)}</span>
        ))}
        {services.length <= 1 && <p>{services.join(", ")}</p>}
      </>
    );
  };

  const tariffsToShow =
    currentInvoiceId === invoice.id && customTariffs && customTariffs.length > 0
      ? customTariffs
      : invoice?.tariffs || [];

  return (
    <Card>
      <Header onClick={() => onToggle(invoice.id)}>
        <HeaderContent>
          <InvoiceInfo>
            <InvoiceTitle>{`${month} - ${year}`}</InvoiceTitle>
            <InvoiceServiceContainer>
              {renderServices(invoice.servicesType)}
            </InvoiceServiceContainer>

            <InvoiceTotal>
              {Number(invoice.amount).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL"
              })}
            </InvoiceTotal>
          </InvoiceInfo>
          <ChevronAndBadgeContainer>
            <InvoiceBadge status={invoice.status}>
              {invoiceStatusMap[invoice.status as InvoiceStatusEnum]}
            </InvoiceBadge>
            {expanded ? <ChevronDownMedIcon /> : <ChevronRightMedIcon />}
          </ChevronAndBadgeContainer>
        </HeaderContent>
      </Header>

      {expanded && (
        <Content>
          <Separator />
          {isLoadingTariffs && currentInvoiceId === invoice.id ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "1rem"
              }}
            >
              <Spinner size={SpinnerSize.small} label="Carregando tarifas..." />
            </div>
          ) : (
            <>
              <TariffList>
                <InvoiceResume
                  selected={selectedTariff === null}
                  onClick={() => onTariffSelect(null)}
                />

                {tariffsToShow.map(tariff => (
                  <TariffItem
                    key={tariff.id}
                    tariff={tariff}
                    selected={selectedTariff?.id === tariff.id}
                    onClick={onTariffSelect}
                  />
                ))}
              </TariffList>
            </>
          )}
        </Content>
      )}
    </Card>
  );
}
